import angular from 'angular'

import { toPosPixel } from '../utils/bits'

angular
  .module('ggs.gallery-preview-flow')
  .factory('PostSpaceStyleHandler', PostSpaceStyleHandlerProvider)

function PostSpaceStyleHandlerProvider(rootQs, GSNApplyStyleTmpl) {

  const OWNER_TAG = __filename

  const MARGIN_BOTTOM_PLH = ':margin-bottom:'
  const MARGIN_RIGHT_PLH  = ':margin-right:'
  const MARGIN_LEFT_PLH   = ':margin-left:'
  const MARGIN_TOP_PLH    = ':margin-top:'

  const BORDER_WIDTH_PLH  = ':cmp-border-width:'
  const BORDER_RADIUS_PLH = ':cmp-border-radius:'

  const STYLE_TMPL = `
    ${rootQs} .ggs-gallery-preview {
      margin-bottom: ${MARGIN_BOTTOM_PLH};
      margin-right:  ${MARGIN_RIGHT_PLH};
      margin-left:   ${MARGIN_LEFT_PLH};
      margin-top:    ${MARGIN_TOP_PLH};
      border-width:  ${BORDER_WIDTH_PLH};
      border-radius: ${BORDER_RADIUS_PLH};
    }`

  const BORDER_WIDTH = 2

  const BOTTOM_COEF = 0.5
  const RIGHT_COEF = 0.5
  const LEFT_COEF = 0.5
  const TOP_COEF = 0.5

  // main

  return function PostSpaceStyleHandler(extFlowResize) {

    const applyPostSpace = GSNApplyStyleTmpl({
      propKeys: [
        'post_space',
        'post_border_radius',
        'preview_stroke_show'
      ],
      ownerTag: OWNER_TAG,
      allowEmpty: false,
      styleFunc: makePostSpace,
      afterFunc: extFlowResize
    })

    return [
      applyPostSpace
    ]

    function makePostSpace(post_space, post_border_radius, preview_stroke_show) {
      const borderWidth = (preview_stroke_show && post_space !== 0) ? BORDER_WIDTH : 0
      const borderRadius = (post_space !== 0) ? post_border_radius : 0

      const marginBottomPx = toPosPixel(Math.ceil(BOTTOM_COEF * post_space) - 2 * BOTTOM_COEF * borderWidth)
      const marginRightPx  = toPosPixel(Math.ceil(RIGHT_COEF * post_space) - 2 * RIGHT_COEF * borderWidth)
      const marginLeftPx   = toPosPixel(Math.ceil(LEFT_COEF * post_space) - 2 * LEFT_COEF * borderWidth)
      const marginTopPx    = toPosPixel(Math.ceil(TOP_COEF * post_space) - 2 * TOP_COEF * borderWidth)

      const borderWidthPx  = toPosPixel(borderWidth)
      const borderRadiusPx = toPosPixel(borderRadius)

      const cssRule = STYLE_TMPL
        .replace(MARGIN_TOP_PLH, marginTopPx)
        .replace(MARGIN_LEFT_PLH, marginLeftPx)
        .replace(MARGIN_RIGHT_PLH, marginRightPx)
        .replace(MARGIN_BOTTOM_PLH, marginBottomPx)
        .replace(BORDER_WIDTH_PLH, borderWidthPx)
        .replace(BORDER_RADIUS_PLH, borderRadiusPx)

      return cssRule
    }
  }
}
